import type { SecretLoadStatus } from '@/components/landing-page/landing-page.types';
import { useEffect } from 'react';
import { useAppDispatch } from '@/redux/store';
import { GeneralSlice } from '@/redux/general';
import Track from '@/utils/track';

export default function useHideElementsPostQid(status: SecretLoadStatus) {
  const dispatch = useAppDispatch();

  const hideHeaderLabel = () => {
    const headerLabel = document.getElementById('banner-label');
    if (headerLabel) {
      headerLabel.style.display = 'none';
    }
  };

  const hideSeoContent = () => {
    const seoContent = document.getElementById('article');
    if (seoContent) {
      seoContent.style.display = 'none';
    }
  };

  useEffect(() => {
    if (status === 'success') {
      hideHeaderLabel();
      hideSeoContent();

      Track.Experiments.LongreadManualActivation();

      dispatch(GeneralSlice.actions.setIsLongReadShown(true));
    }
    return () => {
      dispatch(GeneralSlice.actions.setIsLongReadShown(false));
      const headerLabel = document.getElementById('banner-label');
      if (headerLabel) headerLabel.style.display = '';
      const seoContent = document.getElementById('article');
      if (seoContent) seoContent.style.display = '';
    };
  }, [status]);
}
